import {
  givingBackLinks,
  membershipLinks,
  primaryLink,
  promoCard,
} from '../data/generosityConstants';
import { DesktopMenuColumnLinks } from './components/DesktopMenuColumnLinks';
import { DesktopMenuPrimaryLink } from './components/DesktopMenuPrimaryLink';
import { DesktopMenuPromoCard } from './components/DesktopMenuPromoCard';
import {
  DesktopMenuColumns,
  DesktopMenuContainer,
  DesktopMenuLinks,
} from './desktopMenu.style';

export const GenerosityDesktopMenu = () => {
  return (
    <DesktopMenuContainer>
      <DesktopMenuLinks>
        <DesktopMenuColumns>
          <DesktopMenuColumnLinks links={givingBackLinks} />
          <DesktopMenuColumnLinks links={membershipLinks} />
        </DesktopMenuColumns>
        <DesktopMenuPrimaryLink link={primaryLink} />
      </DesktopMenuLinks>
      <DesktopMenuPromoCard promoCard={promoCard} />
    </DesktopMenuContainer>
  );
};
